export default {
  getMask: (state) => state.phoneMask,
  getCurrency: (state) => state.currency,
  getCurrencySign: (state) => state.currency.currencySign,
  getFooterInfo: (state) => state.footerInfo
}
